jQuery(document).ready(function($) {

	var modifyTabsLayout = function() {
		if ($(window).height()<800) {
			$('body').addClass('short-window');
			$('body').removeClass('medium-window');
		} else if ($(window).height()<1000) {
			$('body').addClass('medium-window');
			$('body').removeClass('short-window');
		} else {
			$('body').removeClass('medium-window');
			$('body').removeClass('short-window');
		}
	}

	var tabsResizeTimeout = false;
	$(window).resize(function() {
		clearTimeout(tabsResizeTimeout);
		tabsResizeTimeout = setTimeout(modifyTabsLayout, 250);
	});
	modifyTabsLayout();

});